var map = {
	"./banner1.jpg": 79183,
	"./banner1_1.jpg": 55753,
	"./banner2.jpg": 72748,
	"./banner2_2.jpg": 31771,
	"./banner3.jpg": 14520,
	"./banner4.jpg": 30354,
	"./banner5.jpg": 76052,
	"./banner5_2.jpg": 71035,
	"./banner6.jpg": 9130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62463;